import parseJwt from '../parseJWT';
import { getItem } from '../localStorage';

/**
 * Get data from localStorage and check if consentMandatory exists
 * if exists and id is the same as the user id there is no need
 * to call the findconsent api
 * @param {sessRemme} string
 * @returns
 */
const checkConsentMandatoryLS = ({ sessRemme }) => {
  let hasToCallConsent = false;
  try {
    const sess = parseJwt(sessRemme);
    const consentMandatory = getItem('consentMandatory');
    const { user: { id } = { } } = sess || {};
    if (!consentMandatory || consentMandatory.id !== id) {
      hasToCallConsent = true;
    }
  } catch (error) {
    console.log('checkConsentMandatoryLS error >>:', error);
    hasToCallConsent = false;
  }
  return hasToCallConsent;
};

export default checkConsentMandatoryLS;
